export const mgPlatformStarIcon = {
  data: `<svg viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M16.5 1.5L20.1207 12.8793H31.5L22.1897 20.1207L25.2931 31.5L16.5 24.2586L7.7069 31.5L10.8103 20.1207L1.5 12.8793H12.8793L16.5 1.5Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>`,
  name: 'star'
}
